/** Código de negócio que o BFF devolve no corpo do erro (`error_code`), quando há um. */
export const getApiErrorCode = (error: unknown): string | undefined => {
  const data = (
    error as
      | { response?: { data?: { error_code?: unknown; code?: unknown } } }
      | undefined
  )?.response?.data

  return (data?.error_code ?? data?.code) as string | undefined
}
